import { useEffect, useState } from "react";
import { InvarDataAccess } from "../../data/InvarDataAccess";
import { ConveyanceResponse } from "../../data/InvarDataModels/ConveyanceResponse";
import {
  Mondrian,
  MondrianColumn,
  MondrianInputObject,
} from "@spt/mondrian/exports";

interface IProps {
  IDA: InvarDataAccess;
}

export const InvarConfig = (props: IProps) => {
  const IDA = props.IDA;

  const [_CreateConveyanceName, setCreateConveyanceName] = useState("");

  const [TheseConveyances, setTheseConveyances] = useState<
    Array<ConveyanceResponse> | undefined
  >(undefined);
  const [ConveyancesLoading, setConveyancesLoading] = useState(true);
  const [ConveyanceLoadingMap, setConveyanceLoadingMap] = useState<
    Array<boolean> | undefined
  >(undefined);

  const [StructuredConveyances, setStructuredConveyances] = useState<
    Array<MondrianInputObject> | undefined
  >(undefined);

  useEffect(() => {
    if (TheseConveyances !== undefined) {
      setConveyancesLoading(false);
      let NewConveyanceLoadingMap = [];
      TheseConveyances.forEach((conveyance) => {
        NewConveyanceLoadingMap[conveyance.ConveyanceID] = false;
      });
      setConveyanceLoadingMap(NewConveyanceLoadingMap);
    }
  }, [TheseConveyances]);

  function UpdateConveyanceLoadingMap(ConveyanceID: number, Loading: boolean) {
    let newMap = [...ConveyanceLoadingMap];
    newMap[ConveyanceID] = Loading;
    setConveyanceLoadingMap(newMap);
  }

  function GetConveyances() {
    IDA.GetConveyances().then((data) => {
      setTheseConveyances(data);
    });
  }

  useEffect(() => {
    if (IDA !== undefined) {
      if (ConveyancesLoading) {
        GetConveyances();
      }
    }
  }, [IDA]);

  const MondrianColumns: MondrianColumn[] = [
    {
      HumanName: "Conveyance",
      MachineName: "Name",
      Sortable: true,
      Groupable: false,
      Filterable: true,
      Hideable: false,
    },
    {
      HumanName: "View",
      MachineName: "View",
      Sortable: false,
      Groupable: false,
      Filterable: false,
      Hideable: false,
    },
    {
      HumanName: "From",
      MachineName: "From",
      Sortable: false,
      Groupable: false,
      Filterable: false,
      Hideable: false,
    },
    {
      HumanName: "To",
      MachineName: "To",
      Sortable: false,
      Groupable: false,
      Filterable: false,
      Hideable: false,
    },
    {
      HumanName: "Description",
      MachineName: "Description",
      Sortable: false,
      Groupable: false,
      Filterable: false,
      Hideable: false,
    },
    {
      HumanName: "Status",
      MachineName: "Status",
      Sortable: true,
      Groupable: true,
      Filterable: false,
      Hideable: false,
    },
    {
      HumanName: "Enable/Disable",
      MachineName: "Actions",
      Sortable: false,
      Groupable: false,
      Filterable: false,
      Hideable: false,
    },
    {
      HumanName: "_ROW_PROCESSING",
      MachineName: "_ROW_PROCESSING",
      Sortable: false,
      Groupable: false,
      Filterable: false,
      Hideable: false,
    },
  ];

  useEffect(() => {
    if (TheseConveyances !== undefined) {
      const StructuredConveyances: MondrianInputObject[] = [];

      TheseConveyances.sort((l, r) => {
        return l.ConveyanceID - r.ConveyanceID;
      }).forEach((thisconveyance, i) => {
        StructuredConveyances.push({
          Name: thisconveyance.Name,
          View: {
            _TYPE: "Element",
            ElementValue: (
              <a
                className="Mondrian_Button Split"
                href={
                  "/AdminPortal/Invar/Conveyance/" +
                  thisconveyance.ConveyanceID.toString()
                }
                target="_blank"
              >
                <span className="Mondrian__Icon_Neutral Bump">⇗</span>
                <span>View Structure</span>
              </a>
            ),
            SortingValue: "",
            GroupingValue: "",
          },
          Description: thisconveyance.Description,
          From: thisconveyance.From,
          To: thisconveyance.To,
          Status: thisconveyance.Active ? "Enabled" : "Disabled",
          Status_CSS: thisconveyance.Active ? "EnabledCharm" : "DisabledCharm",
          Actions: {
            _TYPE: "Element",
            ElementValue: (
              <>
                {thisconveyance.Active ? (
                  <button
                    onClick={() => {
                      UpdateConveyanceLoadingMap(
                        thisconveyance.ConveyanceID,
                        true,
                      );
                      IDA.DisableConveyance(thisconveyance.ConveyanceID).then(
                        (res) => {
                          setTheseConveyances(
                            [...TheseConveyances]
                              .filter(
                                (th) => th.ConveyanceID !== res.ConveyanceID,
                              )
                              .concat(res),
                          );
                        },
                      );
                    }}
                  >
                    Disable
                  </button>
                ) : (
                  <button
                    onClick={() => {
                      UpdateConveyanceLoadingMap(
                        thisconveyance.ConveyanceID,
                        true,
                      );
                      IDA.EnableConveyance(thisconveyance.ConveyanceID).then(
                        (res) => {
                          setTheseConveyances(
                            [...TheseConveyances]
                              .filter(
                                (th) => th.ConveyanceID !== res.ConveyanceID,
                              )
                              .concat(res),
                          );
                        },
                      );
                    }}
                  >
                    Enable
                  </button>
                )}
              </>
            ),
          },
        });
      });

      setStructuredConveyances(StructuredConveyances);
    }
  }, [TheseConveyances]);

  return (
    <div className="InvarConfigSurface">
      <div className="NewConveyance">
        <h3>Create new Conveyance</h3>
        <div className="Cassette">
          <label htmlFor="CCNin">Name</label>
          <input
            id="CCNin"
            type="textbox"
            value={_CreateConveyanceName}
            onChange={(e) => {
              setCreateConveyanceName(e.target.value);
            }}
          ></input>
          <button
            onClick={() => {
              IDA.CreateConveyance(_CreateConveyanceName, "", "", "").then(
                (data) => {
                  setTheseConveyances([...TheseConveyances].concat(data));
                  setCreateConveyanceName(undefined);
                },
              );
            }}
          >
            Create
          </button>
        </div>
      </div>
      <h1>Invar Config</h1>
      {ConveyancesLoading ? (
        <div className="LoadingPanel Block"></div>
      ) : (
        <Mondrian
          Name="InvarConfig"
          Caption="Current Config of all Invar Conveyances and Brokerages."
          Debug={false}
          InputObjects={StructuredConveyances}
          LoadingFlag={ConveyancesLoading}
          Settings={{
            DisplaySettings: { DisplayColumnHeaders: true },
            PagerSettings: { ResultsPerPage: 100 },
          }}
          Columns={MondrianColumns}
        ></Mondrian>
      )}
    </div>
  );
};
